import type { ErrorResponseDetail } from '@/TcxApi/ErrorResponse'

/** Why the API refused the picture (check one_person), and the message for it */
const REASON_KEYS: Record<string, string> = {
	not_photo: 'mypresence.errorUploadNotPhoto',
	no_face: 'mypresence.errorUploadNoFace',
	people: 'mypresence.errorUploadPeople',
	child: 'mypresence.errorUploadChild',
}

/**
 * Picks the message to show when uploading the employee picture fails
 * @param error What the upload threw - the API's error object, or anything else on network errors
 * @returns I18n key: the one-person refusal (422, check one_person) has a message per reason and a general one without a known reason,
 * everything else the generic message
 */
export function pictureUploadErrorKey(error: Partial<ErrorResponseDetail> | Error | undefined) {
	if (!error || !('check' in error) || error.check !== 'one_person') { return 'mypresence.errorUploadMessage' }

	return error.reason && Object.hasOwn(REASON_KEYS, error.reason) ? REASON_KEYS[error.reason] : 'mypresence.errorUploadOnePerson'
}
